(function(){
  /* Filtri degli elenchi dei libri (1 ott 2026): via Prezzo, Disponibilità, Altri filtri; Categoria si chiama Area;
     Autori in una tendina; Anno con una barra «dal … al …»; ordine Area, Collana, Autori, Anno, Formato. */
  function testo(g){var t=g.querySelector('summary .element-text');return t?t.textContent.trim():''}
  function migliora(){
    var side=document.querySelector('.collection-sidebar');if(!side)return;
    var form=side.querySelector('form.filter-form');if(!form)return;
    function applica(){form.dispatchEvent(new Event('input',{bubbles:true}))}
    function ferma(e){e.stopPropagation()}
    var gruppi=[].slice.call(side.querySelectorAll('[class*="collection-sidebar__group--"]')),per={};
    gruppi.forEach(function(g){per[testo(g)]=g});
    ['Prezzo','Altri filtri'].forEach(function(n){if(per[n]&&per[n].style.display!=='none')per[n].style.display='none'});
    if(per['Categoria']){per['Categoria'].querySelector('summary .element-text').textContent='Area';per['Area']=per['Categoria']}
    var ga=per['Autori'];
    if(ga&&!ga.getAttribute('data-ares')){
      var cbs=[].slice.call(ga.querySelectorAll('input[type=checkbox]')),lista=ga.querySelector('filter-list');
      if(cbs.length&&lista){
        var sel=document.createElement('select');sel.className='ares-sel';sel.setAttribute('aria-label','Autore');
        sel.innerHTML='<option value="">Tutti gli autori</option>';
        cbs.forEach(function(cb,i){
          var lab=cb.closest('label')||ga.querySelector('label[for="'+cb.id+'"]');
          var o=document.createElement('option');o.value=String(i);
          o.textContent=lab?lab.textContent.trim().replace(/\s+/g,' '):cb.value;
          if(cb.checked)o.selected=true;sel.appendChild(o);
        });
        sel.addEventListener('input',ferma);
        sel.addEventListener('change',function(e){e.stopPropagation();cbs.forEach(function(cb,i){cb.checked=(String(i)===sel.value)});applica()});
        lista.style.display='none';lista.parentNode.insertBefore(sel,lista);ga.setAttribute('data-ares','1');
      }
    }
    var gy=per['Anno'];
    if(gy&&!gy.getAttribute('data-ares')){
      var anni=[].slice.call(gy.querySelectorAll('input[type=checkbox]')).map(function(cb){return {cb:cb,y:parseInt(cb.value,10)}})
        .filter(function(o){return !isNaN(o.y)}).sort(function(a,b){return a.y-b.y});
      var la=gy.querySelector('filter-list');
      if(anni.length>1&&la){
        var mn=anni[0].y,mx=anni[anni.length-1].y,sc=anni.filter(function(o){return o.cb.checked});
        var a=sc.length?sc[0].y:mn,b=sc.length?sc[sc.length-1].y:mx;
        var w=document.createElement('div');w.className='ares-anni';
        w.innerHTML='<div class="ares-anni__barra"><span class="ares-anni__pieno"></span><input type="range" aria-label="Dall\'anno" min="'+mn+'" max="'+mx+'" step="1" value="'+a+'"><input type="range" aria-label="All\'anno" min="'+mn+'" max="'+mx+'" step="1" value="'+b+'"></div><div class="ares-anni__val"></div>';
        var r=w.querySelectorAll('input'),v=w.querySelector('.ares-anni__val'),p=w.querySelector('.ares-anni__pieno');
        function limiti(){var x=Math.min(+r[0].value,+r[1].value),z=Math.max(+r[0].value,+r[1].value);
          v.textContent=(x===mn&&z===mx?'Tutti, dal '+x+' al '+z:(x===z?'Pubblicati nel '+x:'Pubblicati dal '+x+' al '+z));
          var s=mx-mn||1;p.style.left=((x-mn)/s*100)+'%';p.style.right=((mx-z)/s*100)+'%';return [x,z]}
        limiti();
        [].forEach.call(r,function(inp){
          inp.addEventListener('input',function(e){e.stopPropagation();limiti()});
          inp.addEventListener('change',function(e){e.stopPropagation();var l=limiti(),tutto=(l[0]===mn&&l[1]===mx);
            anni.forEach(function(o){o.cb.checked=!tutto&&o.y>=l[0]&&o.y<=l[1]});applica()});
        });
        la.style.display='none';la.parentNode.insertBefore(w,la);gy.setAttribute('data-ares','1');
      }
    }
    var ordine=['Area','Collana','Autori','Anno','Formato','Disponibilità'];
    var rif=per['Autori']||per['Area']||per['Collana'],cont=rif?rif.parentNode:null;
    if(cont){var voluti=ordine.filter(function(n){return per[n]&&per[n].parentNode===cont}),ora=[].filter.call(cont.children,function(c){return voluti.some(function(n){return per[n]===c})});
      var giusto=ora.every(function(c,i){return c===per[voluti[i]]});
      if(!giusto)voluti.forEach(function(n){cont.appendChild(per[n])})}
    if(cont)offerta(cont);
    chipAnni(per['Anno']);
  }
  /* Link «Libri in offerta» in fondo ai filtri */
  function offerta(cont){
    if(!cont)return;
    var d=cont.querySelector('.ares-offerta');
    if(!d){d=document.createElement('div');d.className='ares-offerta';var on=location.pathname.indexOf('/collections/libri-in-offerta')===0;d.innerHTML='<a href="/collections/libri-in-offerta"'+(on?' aria-current="page"':'')+'><span class="ares-offerta__ico">%</span>Libri in offerta</a>';cont.appendChild(d)}
    else if(d.nextElementSibling)cont.appendChild(d);
  }
  /* Un solo bollino per gli anni scelti, invece di uno per anno */
  function chipAnni(gy){
    if(!gy)return;
    var K='filter.p.m.custom.anno_di_pubblicazione';
    var scelti=[].slice.call(gy.querySelectorAll('input[type=checkbox]')).filter(function(cb){return cb.checked}).map(function(cb){return cb.value});
    if(!scelti.length)return;
    var ys=scelti.map(function(s){return parseInt(s,10)}).sort(function(x,y){return x-y});
    var testo=(ys[0]===ys[ys.length-1])?('Pubblicati nel '+ys[0]):('Pubblicati dal '+ys[0]+' al '+ys[ys.length-1]);
    [].forEach.call(document.querySelectorAll('.tag-list--active-tags'),function(l){
      if(l.querySelector('.ares-chip-anni'))return;
      var prima=null;
      [].forEach.call(l.querySelectorAll('a.element-chip--active'),function(x){if(scelti.indexOf(x.textContent.trim())>-1){var tg=x.closest('.tag')||x;tg.style.display='none';if(!prima)prima=tg}});
      if(!prima)return;
      var c=prima.cloneNode(true);c.style.display='';c.classList.add('ares-chip-anni');
      var ln=c.querySelector('a')||c,u=new URL(ln.getAttribute('href'),location.origin);u.searchParams.delete(K);u.searchParams.delete('page');
      ln.setAttribute('href',u.pathname+u.search);var sp=ln.querySelector('span');if(sp)sp.textContent=testo;
      prima.parentNode.insertBefore(c,prima);
    });
  }
  /* Via le voci «Data» dall'ordinamento: ordinano per data di caricamento, non di uscita */
  function senzaData(){[].forEach.call(document.querySelectorAll('option[value^="created-"],.filter-sort[data-value^="created-"]'),function(o){o.remove()})}
  function via(){migliora();senzaData()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',via);else via();
  if(window.MutationObserver)new MutationObserver(function(){migliora();senzaData()}).observe(document.documentElement,{childList:true,subtree:true});
})();
